<template>
  <v-card class="pa-4">
    <v-row align="center">
      <v-col cols="3">
        <router-link
          v-if="!isDeletedStatus"
          :to="{ name: 'OrderDetail', params: { id: orderId } }"
          class="font-weight-bold"
        >
          {{ code }}
        </router-link>
        <span
          v-else
          class="font-weight-bold">
          {{ code }}
        </span>
      </v-col>

      <v-col cols="3">
        {{ createdAt | dateTimeFormat("DD MMM YYYY - HH:mm") }}
      </v-col>

      <v-col cols="3">
        <order-status-label
          :status="status"
          :deleted-type="deletedType"></order-status-label>
      </v-col>

      <v-col
        cols="3"
        class="text-end">
        <v-btn
          v-if="['new', 'pending', 'rejected'].includes(status)"
          text
          small
          :to="{ name: 'OrderEdit', params: { productType: type, id: orderId } }"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn
          v-if="['new','rejected'].includes(status)"
          text
          small
          color="error"
          @click="$emit('delete',orderId,code)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
        <v-btn
          text
          small
          color="primary"
          @click="toggleIsExpanded">
          ดูเพิ่มเติม
          <v-icon
            v-if="isExpanded"
            right>
            mdi-chevron-up
          </v-icon>
          <v-icon
            v-else
            right>
            mdi-chevron-down
          </v-icon>
        </v-btn>
      </v-col>

      <v-col
        v-if="isRejectStatus && rejectReason"
        cols="12"
        class="pt-0"
      >
        <span class="error--text _fs-14">
          **{{ rejectReason }}
        </span>
      </v-col>
      <v-col
        v-if="isDeletedStatus && !isCancelByUser"
        cols="12"
        class="pt-0"
      >
        <span class="error--text _fs-14">
          **{{ deleteReason || "รายการสั่งซื้อหมดอายุ เนื่องจากไม่มีการชำระภายใน 30 วันตามกำหนด" }}
        </span>
      </v-col>
    </v-row>

    <template v-if="isExpanded">
      <v-row>
        <v-col :cols="isNewLineOfficialAccount || isTransferLineOfficialAccount ? 4 : 8">
          <div>
            รายการที่ซื้อ
          </div>
          <ul>
            <li
              v-for="orderItem in orderItems"
              :key="orderItem._id">
              {{ orderItem.productName }}
            </li>
          </ul>
        </v-col>
        <v-col
          v-if="isNewLineOfficialAccount || isTransferLineOfficialAccount"
          cols="4">
          <div>
            ประเภทลูกค้า
            <div class="primary--text font-weight-bold">
              {{ newLineOfficialAccountTypeText }}
            </div>
          </div>
          <template v-if="isTransferLineOfficialAccount">
            <div class="mt-4">
              Basic ID:
              <span class="primary--text font-weight-bold">
                {{ basicId }}
              </span>
            </div>
            <div class="mt-4">
              ช่องทางที่เคยชำระเงินมาก่อน
              <div class="primary--text font-weight-bold">
                {{ transferAgencyPaymentTypeText }}
              </div>
            </div>
          </template>
        </v-col>
        <v-col
          cols="4"
          class="text-right">
          <v-btn
            v-if="['new', 'pending', 'rejected'].includes(status)"
            class="mb-4"
            color="primary"
            rounded
            min-width="200"
            :href="`/upload-slip/${orderId}`"
          >
            แจ้งชำระเงิน
          </v-btn>
          <v-btn
            v-if="!isDeletedStatus"
            color="primary"
            rounded
            outlined
            min-width="200"
            :to="{ name: 'OrderDetail', params: { id: orderId } }"
          >
            <v-icon left>
              mdi-file
            </v-icon>
            ดูใบเสนอราคา
          </v-btn>
        </v-col>
      </v-row>

      <div class="mt-4">
        สร้างโดย: <span class="font-weight-bold">{{ createdBy }}</span>
      </div>
      <div
        v-if="isNewStatus"
        class="mt-4">
        <span class="error--text _fs-14">
          *** หมายเหตุ Order ยังไม่แจ้งชำระเงินให้ทำการชำระเงินภายใน 30 วัน หลังจากนั้น Order จะถูกยกเลิกอัตโนมัติ
        </span>
      </div>
    </template>
  </v-card>
</template>

<script>

export default {
  name: 'DesktopOrderCard',
  components: {
    OrderStatusLabel: () => import('./OrderStatusLabel')
  },
  props: {
    basicId: {
      type: String,
      default: ''
    },
    orderId: {
      type: String,
      default: ''
    },
    code: {
      type: String,
      default: ''
    },
    createdAt: {
      type: String,
      default: ''
    },
    orderItems: {
      type: Array,
      default: () => []
    },
    createdBy: {
      type: String,
      default: ''
    },
    status: {
      type: String,
      default: ''
    },
    rejectReason: {
      type: String,
      default: ''
    },
    deleteReason: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    isNewLineOfficialAccount: {
      type: Boolean,
      default: false
    },
    isTransferLineOfficialAccount: {
      type: Boolean,
      default: false
    },
    newLineOfficialAccountTypeText: {
      type: String,
      default: ''
    },
    transferAgencyPaymentTypeText: {
      type: String,
      default: ''
    },
    isJuristicCustomer: {
      type: Boolean,
      default: false
    },
    hasPaymentAttachment: {
      type: Boolean,
      default: false
    },
    deletedType: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isExpanded: false
    }
  },
  computed: {
    isRejectStatus () {
      return this.status === 'rejected'
    },
    isDeletedStatus () {
      return this.status === 'deleted'
    },
    isCancelByUser () {
      return this.deletedType === 'userCancel'
    },
    isNewStatus () {
      return this.status === 'new'
    }
  },
  methods: {
    toggleIsExpanded () {
      this.isExpanded = !this.isExpanded
    }
  }
}
</script>
